import { ThemeProvider } from "@mui/material";
import ReactDOM from "react-dom/client";
import App from "./app/App";
import theme from "./styles/theme";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <ThemeProvider theme={theme}>
    <App />
  </ThemeProvider>
);
